import React from "react";
import { useLocation } from "react-router-dom";
import useLinks from "../hooks/useLinks";

const SocialSidebar = () => {
    const location = useLocation();
    const dynamicLinks = useLinks();

    // Hide sidebar on admin, auth, and dashboard routes
    if (location.pathname.startsWith('/admin') || location.pathname.startsWith('/labincharge') || location.pathname.startsWith('/student') || location.pathname.startsWith('/auth')) {
        return null;
    }

    const socialLinks = [
        {
            name: "TWITTER",
            icon: "fa-brands fa-x-twitter",
            url: dynamicLinks.social_twitter || "#",
            bgColor: "#000000",
        },
        {
            name: "LINKEDIN",
            icon: "fa-brands fa-linkedin-in",
            url: dynamicLinks.social_linkedin || "#",
            bgColor: "#3177B0",
        },
        {
            name: "INSTAGRAM",
            icon: "fa-brands fa-instagram",
            url: dynamicLinks.social_instagram || "#",
            bgColor: "#D6306D",
        },
        {
            name: "FACEBOOK",
            icon: "fa-brands fa-facebook-f",
            url: dynamicLinks.social_facebook || "#",
            bgColor: "#4267B2",
        },
        {
            name: "YOUTUBE",
            icon: "fa-brands fa-youtube",
            url: dynamicLinks.social_youtube || "#",
            bgColor: "#FF0000",
        },
    ];

    return (
        <>
            <style>
                {`
                .social-sidebar-container {
                    position: fixed;
                    left: 0;
                    top: 50%;
                    transform: translateY(-50%);
                    z-index: 50;
                    display: flex;
                    flex-direction: column;
                    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
                }
                .social-sidebar-item {
                    display: flex;
                    align-items: center;
                    overflow: hidden;
                    width: 3rem; /* 48px */
                    height: 3rem; /* 48px */
                    color: white;
                    transition: all 0.3s ease-in-out;
                    text-decoration: none;
                }
                .social-sidebar-item:hover {
                    width: 10rem; /* 160px */
                }
                .social-sidebar-icon {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 3rem;
                    height: 3rem;
                    flex-shrink: 0;
                    font-size: 1.25rem;
                }
                .social-sidebar-text {
                    font-weight: 700;
                    font-size: 0.875rem;
                    letter-spacing: 0.05em;
                    white-space: nowrap;
                    opacity: 0;
                    transition: opacity 0.3s ease-in-out;
                    margin-left: 0.5rem;
                }
                .social-sidebar-item:hover .social-sidebar-text {
                    opacity: 1;
                }
                @media (min-width: 1024px) {
                    .social-sidebar-item {
                        width: 3.5rem; /* 56px */
                        height: 3.5rem; /* 56px */
                    }
                    .social-sidebar-item:hover {
                        width: 12rem; /* 192px */
                    }
                    .social-sidebar-icon {
                        width: 3.5rem;
                        height: 3.5rem;
                        font-size: 1.5rem;
                    }
                    .social-sidebar-text {
                        font-size: 1rem;
                    }
                }
                `}
            </style>
            <div className="social-sidebar-container">
                {socialLinks.map((link, index) => (
                    <a
                        key={index}
                        href={link.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="social-sidebar-item"
                        style={{ backgroundColor: link.bgColor }}
                        title={link.name}
                    >
                        <div className="social-sidebar-icon">
                            <i className={link.icon}></i>
                        </div>
                        <span className="social-sidebar-text">
                            {link.name}
                        </span>
                    </a>
                ))}
            </div>
        </>
    );
};

export default SocialSidebar;
